export const jobsDesc = [
  {
    jobtitle: "Database Developer",
    link: "/database-developer",
    metaTitle: "Database Developer: 5+ Years - Job Description | Idexcel",
    jobdesc: [
      "Minimum 3+ Years of hands-on exposure in Rest Assured.",
      "Develop Test Framework for API's and Front end/Backend testing.",
      "Conducting and solving complex integration test cases.",
      "Expertise in API testing automation with strong programming skills.",
      "Proficiency in OOPS concept (Java).",
      "Experience in CI/CD and AWS Deployment.",
      "Maven, TestNG, POM, Cucumber, RESTQL.",
      "RPA Tool, Agile, JIRA, GIT, Deployment Pipeline, AWS.",
      "Design, develop and execute automation script using open source.",
      "Track quality assurance metrics.",
    ],
  },
  {
    jobtitle: "Data Scientist",
    link: "/data-scientist",
    metaTitle: "Data Scientist: 3 to 8 Years - Job Description | Idexcel",
    jobdesc: [
      " Must-Have: ML, Deep learning, NLP, (AWS or Azure or Google cloud), Python, Computer Vision.",
      "  Minimum of 4+ years of relevant experience in implementing and deploying Machine Learning solutions (using various models, such as Linear/Logistic Regression, Support Vector Machines, (Deep) Neural Networks, Hidden Markov Models, Conditional Random Fields, Topic Modeling, Game Theory, Mechanism Design, etc.) ",
      "  Knowledge of LLM Models.",
      " Extensive experience in handling Time-series data.",
      " Experience in working on anomaly detection.",
      " Experience in handling structured and unstructured data.",
      " Strong hands-on experience with statistical packages and ML libraries (e.g., Python scikit learn, Spark MLlib, etc.)",
      " Experience in developing and debugging in one or more of the languages Python.",
    ],
  },
  {
    jobtitle: "AWS Cloud Engineer",
    link: "/aws-cloud-engineer",
    metaTitle: "AWS Cloud Engineer: 4 to 10 Years- Job Description | Idexcel",
    jobdesc: [
      "Hands-on Experience on implementing solutions on AWS following well-architected framework.",
      "Hands-on Experience in Compute, Storage, Management, Governance, Security & Compliance services (EC2/ECS, S3, IAM, Lambda, Api Gateway, SNS, SQS, Kinesis, CloudWatch, CloudFront, Code Pipeline, Code Build, Code Deploy, Config, Guard Duty, Security Hub, AWS Developer Tools etc.)",
      "Hands-on experience in CloudFormation templates/IaC.",
      "Experience / Understanding of DevOps process and tools (AWS, Jenkins, Ansible etc.)",
      "Knowledge in AWS Accounts administration / Management - AWS Organizations, SCPs, Consolidated Billing",
      "Knowledge of information security standards & requirements (ISO, SOC2 etc.)",
      "Development background - Python/Nodejs/.net/java",
      "Good to Have: Knowledge of shell scripting.",
    ],
  },
  {
    jobtitle: "Full Stack Developer",
    link: "/full-stack-developer",
    metaTitle: "Full Stack Developer - Job Description | Idexcel",
    jobdesc: [
      "Expertise in Javascript, , NodeJS, React.JS, Angular JS and Jest",
      "5+ years of experience in front-end and Backend web development using JS framework (React.JS, Node.js, Angular)",
      "2 to 3 years of experience with a JS unit testing library (Jest, Mocha)",
      "2 to 3 years of experience in database technology preferably RDBMS/ ORDBMS",
      "2+ years of experience with Github and advanced Github features",
      "Experience working with large microservice-based architectures",
    ],
  },
  {
    jobtitle: "NodeJS Developer",
    link: "/nodejs-developer",
    metaTitle: "NodeJS Developer - Job Description | Idexcel",
    jobdesc: [
      " Overall 7+ years of work experience in software development.",
      "5+yrs of work experience relevant in NodesJS is mandatory.",
      "Must be strong in coding.",
      "Experience on building services using Rest API is Mandatory.",
      "Experience in leading / mentoring a technical team comprising of people not less than 2.",
      "Experience with relational and non-relational (e.g. MySQL, Mongo DB / Dynamo Db etc.)",
      "Experience with any of the following: code refactoring, design patterns, design driven development, continuous integration, building highly scalable applications, application security.",
      "Knowledge on cloud infrastructure, especially AWS cloud and container technologies like Docker is a plus",
      "Building mobile, responsive/adaptive applications (e.g., Native Mobile Application / React Native) is a plus",
    ],
  },
  {
    jobtitle: "Java Micro-Service Developers (5-7 years of experience)",
    link: "/java-micro-service-developers",
    metaTitle: "Java Micro-Service Developers (5-7 years of experience) - Job Description | Idexcel",
    jobdesc: [
      " Senior Developer with strong analytical and technical ability with over 5 years of experience in enterprise Web applications, REST services and Workflow Processing Service development using Java/J2EE technologies.",
      "Should have strong knowledge and hands on experience in JAVA (Version 1.8 or above) / J2EE / Spring boot / restful Web Services",
      "Expertise in Server less, tomcat (Embedded/Non-Embedded), jetty (Embedded/Non-Embedded), WebSphere",
      "Should have strong insight on OOPS concept and good hands on experience on JAVA (Version 1.8 or above) / J2EE / Spring boot / restful Web Services, Spring IOC, Spring Annotation, Spring Security.",
      "Expertise in mocking, Junit and perf testing of solutions.",
      "Should possess basic Unix/Linux knowledge to be able to write and understand basic shell scripts and basic Unix commands",
      "Knowledge of Oracle (PL/SQL), NoSQL-Mongo, Rules Engine,",
      "Candidates with working knowledge on Docker / Kubernetes / OpenShift / Mesos is a plus.",
      "Have basic experience in Data Preparation Tools Experience with CI/CD build pipelines and toolchain – Git, BitBucket, TeamCity, Artifactory, Jira Experience.",
      "Knowledge of testing concepts (TDD) is a plus.",
      "Strong design skills on Java/J2EE based solutions with Postgres/Mongo backend",
      "Person should have worked in Agile/DevOps Environment.",
    ],
  },
  {
    jobtitle: "Data Engineer",
    link: "/data-engineer",
    metaTitle: "Data Engineer - Job Description | Idexcel",
    jobdesc: [
      " Masters or PhD in Computer Science, Physics, Engineering or Math.",
      "Experience in data mining, large scale data acquisition, transformation, and cleaning.",
      "Hands on experience working on large-scale data science/data analytics projects.",
      "Ability to lead effectively across organizations.",
      "Hands-on experience with Data Analytics technologies such as AWS, ,Spark, Spark SQL, Python",
      "Implementing AWS services in a variety of distributed computing, enterprise environments.",
      "Proficiency with at least one the languages such as Python/Node.JS or Java.",
      "Experience defining system architectures and exploring technical feasibility trade-offs.",
      "3+ years experiences developing cloud software services and an understanding of design for scalability, performance and reliability.",
      "Experience working on a code base with many contributors.",
      "Ability to prototype and evaluate applications and interaction methodologies.",
      "Experience with AWS technology stack.",
    ],
  },
  {
    jobtitle: "Principal AWS Data Solutions Architect",
    link: "/principal-aws-data-solutions-architect",
    metaTitle: "Principal AWS Data Solutions Architect - Job Description | Idexcel",
    jobdesc: [
      "Must have proven history of successfully managing and delivery of complex analytics projects and big data solutions on AWS",
      "Extensive experience in Architecting, designing, and implementing the data flow from on premise application into an AWS Data Lake",
      "Expert in establishing implementation strategies for enterprise data warehouse with primary focus on Business intelligence, Analytics and Data governance.",
      "Expertise in analysis, design, and development of ETL programs and assist in trouble shooting for complex business programs",
      "Hands on expertise in Data ingestion, integration and ETL architecture",
      "Experience in architecting, deploying, and managing cost effective and secure AWS environment across multi-zones and regions",
      "Hands on experience in advanced Data model/Data mart design",
      "Design New Solutions - collaborate with data and engineering architects and development teams to design and build cutting edge AWS data ingestion, enrichment, and accessibility capabilities",
      "AWS Thought Leadership ¬ partner with solution architects and software development engineering teams to provide thought leadership on AWS data capabilities",
      "Cost Effective Engineering – engage with key business stakeholders and technical staff to appropriately understand and recommend solutions that balance AWS costs against the resulting technical benefits.",
      "Advise - Advisory role to executive engineering, data, and product leadership and ability to influence key digital strategies",
      "Hands-on Participation - Hands on participation in the full life cycle of definition, design, implementation, testing, and support.",
    ],
  },
  {
    jobtitle: "Loan SME Business Analyst",
    link: "/loan-sme-business-analyst",
    metaTitle: "Loan SME Business Analyst - Job Description | Idexcel",
    jobdesc: [
      "Well experience in Loan Process (All Loan types - Working capital, Bill Discounting, Term loan, credit line loan, Moorgate loan etc.)",
      "Having experience of 7-10 years.",
      "Having experienced on giving solution from scratch to Loan product.",
      "Well aware of Business Analyst process & documentation.",
      "Preferable as Certified BA",
      "Having experience on US banking system/Products is preferable",
    ],
  },
  {
    jobtitle: "AI Architect",
    link: "/ai-architect",
    metaTitle: " AI Architect- Job Description | Idexcel",
    jobIntro: "We are seeking an innovative and technically hands-on <b>Technical Architect</b> to lead the design and implementation of <b>Generative AI (GenAI)</b> solutions using <b> Large Language Models (LLMs)</b> such as<b> Claude</b>,<b> ChatGPT</b><b> and open-source models </b>(e.g., LLaMA, Mistral). A key aspect of the role will be to integrate <b>agentic capabilities</b>, enabling autonomous and goal-driven AI systems to handle complex enterprise workflows.",
    jobDescHeading: "Required Skills & Experience",
    jobdesc: [
      "10+ years of experience in software architecture with at least 2+ years designing and deploying AI/ML or NLP solutions.",
      "Hands-on experience with <b>LLMs</b> (e.g., ChatGPT, Claude, LLaMA, GPT-4, Gemini),including<b> prompt engineering, fine-tuning</b>, or <b>RAG architectures.</b>",
      "Strong experience in designing and implementing<b> agentic systems </b>where LLMs operate autonomously or in structured workflows (e.g., using <b> LangChain Agents, LangGraph, AutoGen, CrewAI</b>).",
      "Proficient with modern AI development frameworks:<b> LangChain, Transformers, Hugging Face, Vector DBs (e.g., Pinecone, FAISS, Weaviate).</b>",
      "Cloud platform experience: <b>AWS, Azure, or GCP</b>; familiarity with <b>Amazon Bedrock, Azure OpenAI, or Google Generative AI Studio.</b>",
      "Experience in containerization, orchestration (e.g.,<b> Docker, Kubernetes</b>) and MLOps practices.",
      "Strong understanding of <b> data privacy, model governance </b>and <b>ethical AI</b> considerations in enterprise settings.",
      "Excellent communication and leadership skills with a track record of guiding cross-functional teams."
    ],
  },
  {
    jobtitle: "Technical Lead – Ruby on Rails",
    link: "/technical-lead-ruby-on-rails",
    metaTitle: "Technical Lead – Ruby on Rails - Job Description | Idexcel",
    jobDescHeading: "Required Skills",
    jobdesc: [
      "10 to 15 years of strong hands-on expertise in <b> Ruby on Rails, Angular and Node.js </b> for high-throughput backend systems.",
      "Solid understanding of  <b>microservices architecture, REST APIs, event-driven systems.</b>",
      "Proven ability to<b> lead architecture decisions </b>in AWS-based environments.",
      "Expertise in <b>relational and NoSQL databases </b> (PostgreSQL, MySQL, DynamoDB).",
      "Experience in <b> distributed caching and message queuing </b> mechanisms.",
      "Proven ability to lead engineering teams and provide technical direction.",
      "Experience integrating<b> GenAI/LLMs </b>or working with <b> AI infrastructure </b> (e.g., vector DBs, model APIs).",
      "Excellent debugging, profiling, and system <b>performance tuning</b> capabilities.",
      "Knowledge of <b> security best practices, OWASP, and cloud-native security</b>."
    ]
  },
  {
    jobtitle: "Principle AI Engineer",
    link: "/principle-ai-engineer",
    metaTitle: "Principle AI Engineer - Job Description | Idexcel",
    jobDescHeading: "",
    jobdesc: [
      "10+ years of engineering experience with <b>3+ years </b> leading teams.",
      "Built & scaled:",
      // "→ AI/ML or data platforms",
      "➢ AI/ML or data platforms.",
      "➢ Workflow automation or enterprise SaaS.",
      "➢ High-availability, secure production environments.",
      "Deep familiarity with <b> LLMs + Vision Models </b> (OCR not enough).",
      "Strong architectural ability — event-driven, streaming, microservices, vector DB.",
      "Proven ability to turn messy, unstructured data into reliable structured outputs.",
      "Experience in integrating with financial systems: core, GL, banking APIs.",
      "You’ve lived through scale: dozens to hundreds of engineers, before that you have worked at a well-run, high-bar company where you learned what great engineering culture looks like.",
      "A true builder who enjoys hands-on contribution where needed."
    ]
  },
  {
    jobtitle: "Principle Generative AI Solutions Architect",
    link: "/principle-generative-ai-solutions-architect",
    metaTitle: "Principle Generative AI Solutions Architect - Job Description | Idexcel",
    jobDescHeading: "",
    jobdesc: [
      "10+ years of specific technology domain areas (e.g. software development, cloud computing, systems engineering, infrastructure, security, networking, data & analytics) experience.",
      "Bachelor's degree in computer science, engineering, mathematics or equivalent.",
      "Experience developing technology solutions and evangelizing end-to-end technology roadmaps that guide IT transformations toward cloud computing.",
      "Experience communicating across technical and non-technical audiences and at C-level, including training, workshops, and publications.",
      "Reviewing customer requirements and technical challenges, focusing on opportunities to implement autonomous AI agent architectures that can transform business outcomes.",
      "Conduct customer business and technical enablement meetings to discuss how agentic AI solutions can solve complex cloud challenges through self-examination, planning, and multi-agent collaboration.",
      "Develop proof-of-concepts that demonstrate how agentic systems can transform business processes through goal-directed, autonomous operation.",
      "Influencing service team leadership and product marketing on future needs for customers, prioritizing roadmap features and GTM messaging.",
      "Dedicate time to continuous learning about the latest advancements in agentic AI research and AWS service capabilities, particularly focusing on Amazon Bedrock’s evolving capabilities.",
      "Participate in knowledge sharing activities with colleagues, creating field enablement materials to help other SAs understand how to integrate AWS AI agent solutions into customer architectures."
    ]
  },
  {
    jobtitle: "Principle Engineer – Agentic AI (Transforming Lending)",
    link: "/principle-engineer",
    metaTitle: "Principle Engineer – Agentic AI (Transforming Lending) - Job Description | Idexcel",
    jobIntro: [
      "Education: Bachelor's or master's degree in computer science, Artificial Intelligence, or a related field.",
      "Experience: 10+ years of software engineering experience, with a proven track record of designing and building complex, enterprise-grade applications.",
      "AI/ML Expertise:",
      "Deep understanding of AI/ML principles, particularly in the area of Large Language Models (LLMs) and agentic systems.",
      "Experience in developing and deploying AI agents using frameworks and tools.",
      "Strong knowledge of natural language processing (NLP), machine learning, and deep learning techniques."
    ],
    jobDescHeading: "Technical Skills",
    jobDescSubHeading: "",
    jobdesc: [
      "Proficient in programming languages such as Java, Python, Node.js, React.js, and Angular.",
      "Experience with PostgreSQL or other relational databases.",
      "Strong cloud computing experience, particularly with AWS.",
      "Experience with software development best practices, including version control (Git), CI/CD, and testing.",
      "Problem-Solving: Excellent analytical and problem-solving skills, with the ability to break down complex challenges into manageable solutions.",
      "Communication: Strong communication and collaboration skills, with the ability to effectively communicate technical concepts to both technical and non-technical audiences.",
      "Leadership: Proven ability to provide technical leadership, mentorship, and guidance to other engineers.",
      "Passion: A passion for innovation and a strong desire to transform the lending industry with AI."
    ]
  }
];
